export default __webpack_public_path__ + "static/media/mainlogo.26c10bb1.png";